import { Component, OnInit, Inject } from '@angular/core';
import { MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { IProcedureCodes } from 'src/app/models/IProcedureCodes';
import { ManageIcdComponent } from 'src/app/AdminModule/AdminConfiguration/manage-icd/manage-icd.component';
import { ManageICDService } from 'src/app/Services/manage-icd-codes/manage-icd.service';
import { IDxIcdCodes } from 'src/app/models/IDXDetails';

@Component({
  selector: 'app-manageicd-dialog',
  templateUrl: './manageicd-dialog.component.html',
  styleUrls: ['./manageicd-dialog.component.css']
})
export class ManageicdDialogComponent implements OnInit {

  ICDPopUpMasterForm: FormGroup;
  dataSource = new MatTableDataSource();
  blue: string = '#BAFBC1';
  white: string = 'opacity: 0.0';
  searchresults: string = "";
  displayedColumns: string[] = ['Select','cptcode', 'description'];//, 'consumerfriendly'];
  _addedICDCodesList:IDxIcdCodes[]=[];
  constructor(private formBuilder: FormBuilder, 
    private _ManageICDService: ManageICDService, 
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<ManageicdDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IProcedureCodes, public dialog: MatDialog) { }

  ngOnInit() {
    this.ICDPopUpMasterForm = this.formBuilder.group({
      MasterICDlist: ['']
    });

   if(this.data)
   {
    this.ICDPopUpMasterForm.controls["MasterICDlist"].setValue(this.data);
    this.searchMasterCPTcodes();
   }
   this._ManageICDService.getDxAllIcdWithCategory().subscribe((result:IDxIcdCodes[])=>{
    this._addedICDCodesList=result.filter(i=>i.isActive==true);
   });
  }
  fnCheckifAdded(ICDCode:string)
  {
    return (this._addedICDCodesList.filter(i=>i.icdCode==ICDCode).length==0)
  }
  onMasterCptSearch() {
    this.searchMasterCPTcodes();
  }

  public MasterICDList: any[];
  searchMasterCPTcodes() {
    var searchText = this.ICDPopUpMasterForm.controls["MasterICDlist"].value;
    if (searchText != null && searchText != undefined && searchText != '') {
      this._ManageICDService.getICDBySearch(searchText).subscribe(
        results => {
          this.MasterICDList = results;
          if(results.length == 0){
            this.searchresults = "No search results found.";
          }
          else{
            this.searchresults = "";
          }
          
          this.dataSource.data = this.MasterICDList;
        }, (err: any) => console.log(err));
    }
  }

  public newMasterrecord: IProcedureCodes[] = [];
  selectedCPTCodes(index, element: IProcedureCodes, event: boolean) {
    if (event == true) {
      this.MasterICDList[index].background = this.blue;
      this.newMasterrecord.push(element);
    } else {
      this.newMasterrecord = this.newMasterrecord.filter(ele => ele != element);
      this.MasterICDList[index].background = this.white;
    }
  }

  AddCPTMaster() {
    if (this.newMasterrecord.length == 1) {
      this.dialogRef.close(this.newMasterrecord);
    }
    else if (this.newMasterrecord.length > 1) {
      this.toastr.error("Please select only one ICD Code");
    }
    else {

      this.toastr.error("Please select ICD Code");
    }
  }
  AddToParent(element){
    this.dialogRef.close(element);
  }
  selectedRowIndex: number = -1;
  oncellclick(row) {
    this.selectedRowIndex = row.code;
  }
  CancelCPTMaster() {
    this.dialogRef.close('cancel');
  }
}
